export default {
  "Audio Compressor": "Comprimir audio",
  "HitPaw Online Audio Compressor": "HitPaw Compresor de Audio Online",
  "Reduce audio file size online without quality loss.": "Reduce el tamaño del archivo de audio en línea sin pérdida de calidad.",
  "Compress": "Comprimir",
  "Compressing": "Comprimiendo",
  "Compressed Successfully": "Comprimido con éxito",
  "Compress New": "Comprimir nuevo",
  "Compression is complete": "La compresión está completa",
  "Compression failed": "Compresión falló",
  "Quality": "Calidad",
  "Format": "Formato",
  "Add file": "Agregar archivo",
  "Output Settings": "Ajustes de salida",

};
